<div>
  <div class="row table-div">
    <div class="lblScenarioName">
      {{ reportResource.lblScenarioName }} {{ impactItems?.scenarioName }}
    </div>
  </div>
  <div class="row table-div">
    <div class="indicatorName">
      {{ reportResource.lblInputData }} {{ impactItems?.scenarioName }}
    </div>
  </div>
</div>

<div class="row table-div" *ngIf="impactItems?.packagingLevelItems?.length > 0">
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblPackagingLevels }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showPackagingLevelItems?.isNameAllZero">
            {{ reportResource.lblUnit }}
          </td>
          <td
            *ngIf="!impactItems?.showHideScenarioTables?.showPackagingLevelItems?.isAmountAllZero"
          >
            {{ reportResource.lblQtyPackLevel }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showPackagingLevelItems
                ?.isPackageLevelDetailsAllZero
            "
          >
            {{ reportResource.lblPackDetail }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showPackagingLevelItems
                ?.isTotalunitsperPalletAllZero
            "
          >
            {{ impactItems.headerLabel }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="impactItems.packagingLevelItems?.length > 0">
          <tr *ngFor="let items of impactItems.packagingLevelItems">
            <td
              *ngIf="!impactItems?.showHideScenarioTables?.showPackagingLevelItems?.isNameAllZero"
            >
              {{ items.name }}
            </td>
            <td
              *ngIf="!impactItems?.showHideScenarioTables?.showPackagingLevelItems?.isAmountAllZero"
            >
              {{ getShortDecimalFormat(items.amount.toString()) | decimalFormatPipe }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showPackagingLevelItems
                  ?.isPackageLevelDetailsAllZero
              "
            >
              {{ items.packageLevelDetails }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showPackagingLevelItems
                  ?.isTotalunitsperPalletAllZero
              "
            >
              {{ items.totalunitsperPallet | decimalFormatPipe }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="impactItems.isExport && impactItems.componentItems?.length > 0">
  <div class="row table-div" *ngIf="processIncluded?.isMaterial">
    <div class="tableHeadingForLifecycleStage">
      <div>{{ reportResource.lblDetailsComponents }}</div>
    </div>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td
              *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero"
            >
              {{ reportResource.lblComponent }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isPackagingLevelNameAllZero
              "
            >
              {{ reportResource.lblPackagingLevels }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems?.isMaterialNameAllZero
              "
            >
              {{ reportResource.lblMaterial }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isMaterialSupplierNameAllZero
              "
            >
              {{ reportResource.lblSupplierName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isMaterialCountryNameAllZero
              "
            >
              {{ reportResource.lblCountry }}
            </td>
            <td *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isWeightAllZero">
              {{ reportResource.lblWeight }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems?.isRecycledContentAllZero
              "
            >
              {{ reportResource.lblRecycledContent }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isRecycledAllocationFactorAllZero
              "
            >
              {{ reportResource.lblRecycledAllocationFactor }}
            </td>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let items of impactItems.componentItems">
              <td
                *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero"
              >
                {{ items.componentName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isPackagingLevelNameAllZero
                "
              >
                {{ items.packagingLevelName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isMaterialNameAllZero
                "
              >
                {{ items.materialName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isMaterialSupplierNameAllZero
                "
              >
                {{ items.materialSupplierName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isMaterialCountryNameAllZero
                "
              >
                {{ items.materialCountryName }}
              </td>
              <td
                *ngIf="
                  !!items.weight &&
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isWeightAllZero
                "
              >
                {{ convertStringFunction(items.weight.toString()) | decimalFormatPipe }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isRecycledContentAllZero
                "
              >
                {{ items.recycledContent | decimalFormatPipe }}%
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isRecycledAllocationFactorAllZero
                "
              >
                {{ items.recycledAllocationFactor | decimalFormatPipe }}%
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #iSOTable>
  <div>
    <div class="row table-div" *ngIf="processIncluded?.isMaterial">
      <div class="tableHeadingForLifecycleStage">
        <div>{{ reportResource.lblDetailsComponents }}</div>
      </div>
      <div class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td
                *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero"
              >
                {{ reportResource.lblComponent }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isPackagingLevelNameAllZero
                "
              >
                {{ reportResource.lblPackagingLevels }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isMaterialNameAllZero
                "
              >
                {{ reportResource.lblMaterial }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isMaterialSupplierNameAllZero
                "
              >
                Name of material supplier
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isMaterialCountryNameAllZero
                "
              >
                Country of material origin
              </td>
              <td *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isWeightAllZero">
                {{ reportResource.lblWeight }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isRecycledContentAllZero
                "
              >
                {{ reportResource.lblRecycledContent }}
              </td>
              <!-- <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isRecycledAllocationFactorAllZero
              "
            >
              {{ reportResource.lblRecycledAllocationFactor }}
            </td> -->
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr *ngFor="let items of impactItems.componentItems">
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero
                  "
                >
                  {{ items.componentName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems
                      ?.isPackagingLevelNameAllZero
                  "
                >
                  {{ items.packagingLevelName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems?.isMaterialNameAllZero
                  "
                >
                  {{ items.materialName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems
                      ?.isMaterialSupplierNameAllZero
                  "
                >
                  {{ items.materialSupplierName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems
                      ?.isMaterialCountryNameAllZero
                  "
                >
                  {{ items.materialCountryName }}
                </td>
                <td
                  *ngIf="
                    !!items.weight &&
                    !impactItems?.showHideScenarioTables?.showComponentItems?.isWeightAllZero
                  "
                >
                  {{ convertStringFunction(items.weight.toString()) }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems
                      ?.isRecycledContentAllZero
                  "
                >
                  {{ items.recycledContent }}%
                </td>
                <!-- <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isRecycledAllocationFactorAllZero
                "
              >
                {{ items.recycledAllocationFactor }}%
              </td> -->
              </tr>
            </ng-container>
          </tbody>
        </table>

        <br />

        <table
          class="table"
          *ngIf="
            !impactItems?.showHideScenarioTables?.showComponentItems?.isMaterialDataSourceAllZero
          "
        >
          <thead>
            <tr>
              <td
                *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero"
              >
                {{ reportResource.lblComponent }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isMaterialDataSourceAllZero
                "
              >
                Input data source
              </td>
              <!-- <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isRecycledAllocationFactorAllZero
                "
              >
                {{ reportResource.lblRecycledAllocationFactor }}
              </td> -->
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr *ngFor="let items of impactItems.componentItems">
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero
                  "
                >
                  {{ items.componentName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems
                      ?.isMaterialDataSourceAllZero
                  "
                >
                  {{ items.componentDataSourceName }}
                </td>
                <!-- <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showComponentItems
                      ?.isRecycledAllocationFactorAllZero
                  "
                >
                  {{ items.recycledAllocationFactor }}%
                </td> -->
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>

<div
  *ngIf="
    !impactItems.isExport && impactItems?.componentItems?.length > 0 && !isIsoReport;
    else iSOTable
  "
>
  <div class="row table-div" *ngIf="processIncluded?.isMaterial">
    <div class="tableHeadingForLifecycleStage">
      <div>{{ reportResource.lblDetailsComponent }}</div>
    </div>

    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td
              *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero"
            >
              {{ reportResource.lblComponent }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isPackagingLevelNameAllZero
              "
            >
              {{ reportResource.lblPackagingLevels }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems?.isMaterialNameAllZero
              "
            >
              {{ reportResource.lblMaterial }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isMaterialSupplierNameAllZero
              "
            >
              {{ reportResource.lblSupplierName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isMaterialCountryNameAllZero
              "
            >
              {{ reportResource.lblCountry }}
            </td>
            <td *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isWeightAllZero">
              {{ reportResource.lblWeight }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems?.isRecycledContentAllZero
              "
            >
              {{ reportResource.lblRecycledContent }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showComponentItems
                  ?.isRecycledAllocationFactorAllZero
              "
            >
              {{ reportResource.lblRecycledAllocationFactor }}
            </td>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let items of impactItems.componentItems">
              <td
                *ngIf="!impactItems?.showHideScenarioTables?.showComponentItems?.isComponentAllZero"
              >
                {{ items.componentName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isPackagingLevelNameAllZero
                "
              >
                {{ items.packagingLevelName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isMaterialNameAllZero
                "
              >
                {{ items.materialName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isMaterialSupplierNameAllZero
                "
              >
                {{ items.materialSupplierName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isMaterialCountryNameAllZero
                "
              >
                {{ items.materialCountryName }}
              </td>
              <td
                *ngIf="
                  !!items.weight &&
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isWeightAllZero
                "
              >
                {{ convertStringFunction(items.weight.toString()) | decimalFormatPipe }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems?.isRecycledContentAllZero
                "
              >
                {{ items.recycledContent | decimalFormatPipe }}%
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showComponentItems
                    ?.isRecycledAllocationFactorAllZero
                "
              >
                {{ items.recycledAllocationFactor | decimalFormatPipe }}%
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="
    processIncluded?.isConversion &&
    impactItems.componentItems?.length > 0 &&
    getComponenttransportationItems(impactItems?.componentItems)
  "
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblTransportationConvertor }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td style="width: 150px">{{ reportResource.lblDescription }}</td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                ?.isTransportmodeNameAllZero
            "
          >
            {{ reportResource.lblModeTransport }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                ?.isFromplaceAllZero
            "
          >
            {{ reportResource.lblFrom }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                ?.isToplaceAllZero
            "
          >
            {{ reportResource.lblTo }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                ?.isDistanceAllZero
            "
          >
            {{ reportResource.lblDistance }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <ng-container *ngFor="let items of impactItems.componentItems">
            <ng-container
              *ngIf="
                items.componenttransportationItems.length > 0 &&
                items.componenttransportationItems != null
              "
            >
              <ng-container *ngFor="let item of items.componenttransportationItems; let i = index">
                <tr>
                  <ng-container *ngIf="i == 0 || i > items.componenttransportationItems.length">
                    <td [attr.rowspan]="items.componenttransportationItems.length">
                      {{ items.componentName }}
                    </td>
                  </ng-container>
                  <ng-container *ngIf="i === 0; else otherItems">
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isTransportmodeNameAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.transportmodeName }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isFromplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.fromplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isToplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.toplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isDistanceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ getShortDecimalFormat(item.distance) | decimalFormatPipe }}
                    </td>
                  </ng-container>
                  <ng-template #otherItems>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isTransportmodeNameAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.transportmodeName }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isFromplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.fromplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isToplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.toplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showComponenttransportationItems
                          ?.isDistanceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ getShortDecimalFormat(item.distance) | decimalFormatPipe }}
                    </td>
                  </ng-template>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded?.isConversion && impactItems.componentItems?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblConversionProcess }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConversionProcess?.isComponentNameAllZero
            "
          >
            {{ reportResource.lblComponent }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConversionProcess
                ?.isConversionSupplierNameAllZero
            "
          >
            {{ reportResource.lblConvertorName }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConversionProcess
                ?.isConversionProcessNameAllZero
            "
          >
            {{ reportResource.lblConversionProcess }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConversionProcess
                ?.isConversionCountryNameAllZero
            "
          >
            {{ reportResource.lblCountry }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let items of impactItems.componentItems">
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConversionProcess?.isComponentNameAllZero
              "
            >
              {{ items.componentName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConversionProcess
                  ?.isConversionSupplierNameAllZero
              "
            >
              {{ items.conversionSupplierName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConversionProcess
                  ?.isConversionProcessNameAllZero
              "
            >
              {{ items.conversionProcessName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConversionProcess
                  ?.isConversionCountryNameAllZero
              "
            >
              {{ items.conversionCountryName }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div page-break"
  *ngIf="processIncluded?.isProductIncluded && impactItems.productList?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblDetailProduct }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showProductList?.isLabelAllZero">
            {{ reportResource.lblDescription }}
          </td>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showProductList?.isValueAllZero">
            {{ reportResource.lblAmounts }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let productdetail of impactItems.productList; let i = index">
            <td *ngIf="!impactItems?.showHideScenarioTables?.showProductList?.isLabelAllZero">
              {{ productdetail.label }}
            </td>
            <td *ngIf="!impactItems?.showHideScenarioTables?.showProductList?.isValueAllZero">
              {{ productdetail.value }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-container
  *ngIf="
    processIncluded?.isProductIncluded &&
    impactItems.productList?.length > 0 &&
    impactItems?.productDetailList?.length > 0
  "
>
  <div *ngFor="let productItem of impactItems?.productDetailList">
    <div class="row space">
      <div class="lblScenarioName">{{ reportResource.lblProductDetails }}</div>
    </div>
    <div>
      <piqet-angular-report-product-detail
        [impactItems]="productItem?.productDetail"
        [isReportAccess]="true"
      ></piqet-angular-report-product-detail>
    </div>
    <div
      class="row space"
      *ngIf="productItem?.ingredientDetail?.ingredientDataSourceList?.length > 0"
    >
      <div class="lblScenarioName">{{ reportResource.lblIngredientDataSource }}</div>
    </div>
    <div>
      <piqet-angular-report-ingredientdatasource-details
        [impactItems]="productItem?.ingredientDetail"
      ></piqet-angular-report-ingredientdatasource-details>
    </div>
  </div>
</ng-container>

<div
  class="row table-div"
  *ngIf="
    processIncluded?.isPallet &&
    (impactItems.palletName || impactItems.palletMass) &&
    impactItems?.palletName != 'No Pallet'
  "
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblDetailPalletUsed }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td>{{ reportResource.lblDetailPalletUsed }}</td>
          <td>{{ reportResource.lblPalletWeight }}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ impactItems.palletName }}</td>
          <td>{{ impactItems.palletMass | decimalFormatPipe }} kg</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="
    processIncluded?.isFilling &&
    impactItems.fillertransportationItems?.length > 0 &&
    showFillerTransport
  "
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblTransportationFiller }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td>{{ reportResource.lblDescription }}</td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                ?.isTransportmodeNameAllZero
            "
          >
            {{ reportResource.lblModeTransport }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                ?.isFromplaceAllZero
            "
          >
            {{ reportResource.lblFrom }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingtransportationItems?.isToplaceAllZero
            "
          >
            {{ reportResource.lblTo }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                ?.isDistanceAllZero
            "
          >
            {{ reportResource.lblDistance }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <ng-container *ngFor="let items of impactItems.fillertransportationItems">
            <ng-container
              *ngIf="
                items.fillingtransportationItems.length > 0 &&
                items.fillingtransportationItems != null
              "
            >
              <ng-container *ngFor="let item of items.fillingtransportationItems; let i = index">
                <tr>
                  <ng-container *ngIf="i == 0 || i > items.fillingtransportationItems.length">
                    <td [attr.rowspan]="items.fillingtransportationItems.length">
                      {{ items.componentName }}
                    </td>
                  </ng-container>
                  <ng-container *ngIf="i === 0">
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isTransportmodeNameAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.transportmodeName }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isFromplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.fromplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isToplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.toplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isDistanceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ getShortDecimalFormat(item.distance) | decimalFormatPipe }}
                    </td>
                  </ng-container>
                  <ng-container *ngIf="i != 0">
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isTransportmodeNameAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.transportmodeName }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isFromplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.fromplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isToplaceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ item.toplace }}
                    </td>
                    <td
                      *ngIf="
                        !impactItems?.showHideScenarioTables?.showFillingtransportationItems
                          ?.isDistanceAllZero
                      "
                      style="text-align: left"
                    >
                      {{ getShortDecimalFormat(item.distance) | decimalFormatPipe }}
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded?.isFilling && impactItems.fillingItems?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblFillingDetails }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingProcessItems
                ?.isEnergyProcessNameAllZero
            "
          >
            {{ reportResource.lblEnergyRequirement }}
          </td>
          <td
            *ngIf="!impactItems?.showHideScenarioTables?.showFillingProcessItems?.isAmountAllZero"
          >
            {{ reportResource.lblAmount }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingProcessItems?.isProductLossAllZero
            "
          >
            {{ reportResource.lblProductLossFilling }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingProcessItems
                ?.isReuseProductLossAllZero
            "
          >
            {{ reportResource.lblReusedProductLoss }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingProcessItems
                ?.isResaleofproductAllZero
            "
          >
            {{ reportResource.lblResaleProduct }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingProcessItems
                ?.isDestoinationofProductLossAllZero
            "
          >
            {{ reportResource.lblDestinationProductLoss }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showFillingProcessItems?.isCountryNameAllZero
            "
          >
            {{ reportResource.lblCountry }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <ng-container *ngFor="let fillingItems of impactItems.fillingItems">
            <ng-container
              *ngIf="
                fillingItems.fillingProcessItems.length > 0 && !!fillingItems.fillingProcessItems;
                else fillingProcessItems
              "
            >
              <tr *ngFor="let items of fillingItems.fillingProcessItems; let i = index">
                <td
                  *ngIf="
                    i == 0 &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isEnergyProcessNameAllZero
                  "
                >
                  {{ fillingItems.fillingProcessItems[i].energyProcessName }}
                </td>
                <td
                  *ngIf="
                    i == 0 &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems?.isAmountAllZero
                  "
                >
                  {{
                    getShortDecimalFormat(fillingItems.fillingProcessItems[i].amount)
                      | decimalFormatPipe
                  }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    i == 0 &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isProductLossAllZero
                  "
                >
                  {{ fillingItems.productLoss }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    i == 0 &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isReuseProductLossAllZero
                  "
                >
                  {{ getShortDecimalFormat(fillingItems.reuseProductLoss) | decimalFormatPipe }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    i == 0 &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isResaleofproductAllZero
                  "
                >
                  {{ getShortDecimalFormat(fillingItems.resaleofproduct) | decimalFormatPipe }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    i == 0 &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isDestoinationofProductLossAllZero
                  "
                >
                  {{ fillingItems.destoinationofProductLoss }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    i == 0 &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isCountryNameAllZero
                  "
                >
                  {{ fillingItems.countryName }}
                </td>
                <td
                  *ngIf="
                    !(i == 0) &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isEnergyProcessNameAllZero
                  "
                >
                  {{ fillingItems.fillingProcessItems[i].energyProcessName }}
                </td>
                <td
                  *ngIf="
                    !(i == 0) &&
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems?.isAmountAllZero
                  "
                >
                  {{
                    getShortDecimalFormat(fillingItems.fillingProcessItems[i].amount)
                      | decimalFormatPipe
                  }}
                </td>
              </tr>
            </ng-container>

            <ng-template #fillingProcessItems>
              <tr>
                <td></td>
                <td></td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isProductLossAllZero
                  "
                >
                  {{ fillingItems.productLoss }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isReuseProductLossAllZero
                  "
                >
                  {{ getShortDecimalFormat(fillingItems.reuseProductLoss) | decimalFormatPipe }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isResaleofproductAllZero
                  "
                >
                  {{ getShortDecimalFormat(fillingItems.resaleofproduct) | decimalFormatPipe }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isDestoinationofProductLossAllZero
                  "
                >
                  {{ fillingItems.destoinationofProductLoss }}
                </td>
                <td
                  [rowSpan]="fillingItems.fillingProcessItems.length"
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showFillingProcessItems
                      ?.isCountryNameAllZero
                  "
                >
                  {{ fillingItems.countryName }}
                </td>
              </tr>
            </ng-template>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded?.isWholesale && impactItems.wholesaletransportList?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblTransportationWholesaler }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showWholesaletransportList
                ?.isTransportmodeNameAllZero
            "
          >
            {{ reportResource.lblModeTransport }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showWholesaletransportList?.isFromplaceAllZero
            "
          >
            {{ reportResource.lblFrom }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showWholesaletransportList?.isToplaceAllZero
            "
          >
            {{ reportResource.lblTo }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showWholesaletransportList?.isDistanceAllZero
            "
          >
            {{ reportResource.lblDistance }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let items of impactItems.wholesaletransportList">
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showWholesaletransportList
                  ?.isTransportmodeNameAllZero
              "
            >
              {{ items.transportmodeName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showWholesaletransportList?.isFromplaceAllZero
              "
            >
              {{ items.fromplace }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showWholesaletransportList?.isToplaceAllZero
              "
            >
              {{ items.toplace }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showWholesaletransportList?.isDistanceAllZero
              "
            >
              {{ getShortDecimalFormat(items.distance) | decimalFormatPipe }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded?.isWholesale && impactItems.wholesaleItems?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblWholesaleDetails }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showWholesaleItems?.isLabelAllZero">
            {{ reportResource.lblDescription }}
          </td>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showWholesaleItems?.isValueAllZero">
            {{ reportResource.lblInput }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let wholesaledetail of impactItems.wholesaleItems">
            <td *ngIf="!impactItems?.showHideScenarioTables?.showWholesaleItems?.isLabelAllZero">
              {{ wholesaledetail.label }}
            </td>
            <td *ngIf="!impactItems?.showHideScenarioTables?.showWholesaleItems?.isValueAllZero">
              {{ wholesaledetail.value }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded?.isRetail && impactItems.retailtransportList?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblTransportationRetailer }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showRetailtransportList
                ?.isTransportmodeNameAllZero
            "
          >
            {{ reportResource.lblModeTransport }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showRetailtransportList?.isFromplaceAllZero
            "
          >
            {{ reportResource.lblFrom }}
          </td>
          <td
            *ngIf="!impactItems?.showHideScenarioTables?.showRetailtransportList?.isToplaceAllZero"
          >
            {{ reportResource.lblTo }}
          </td>
          <td
            *ngIf="!impactItems?.showHideScenarioTables?.showRetailtransportList?.isDistanceAllZero"
          >
            {{ reportResource.lblDistance }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let retailtransportList of impactItems.retailtransportList">
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showRetailtransportList
                  ?.isTransportmodeNameAllZero
              "
            >
              {{ retailtransportList.transportmodeName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showRetailtransportList?.isFromplaceAllZero
              "
            >
              {{ retailtransportList.fromplace }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showRetailtransportList?.isToplaceAllZero
              "
            >
              {{ retailtransportList.toplace }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showRetailtransportList?.isDistanceAllZero
              "
            >
              {{ getShortDecimalFormat(retailtransportList.distance) | decimalFormatPipe }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div class="row table-div" *ngIf="processIncluded?.isRetail && impactItems.retailItems?.length > 0">
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblRetailDetails }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showRetailItems?.isLabelAllZero">
            {{ reportResource.lblDescription }}
          </td>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showRetailItems?.isValueAllZero">
            {{ reportResource.lblInput }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let retailItems of impactItems.retailItems">
            <td *ngIf="!impactItems?.showHideScenarioTables?.showRetailItems?.isLabelAllZero">
              {{ retailItems.label }}
            </td>
            <td *ngIf="!impactItems?.showHideScenarioTables?.showRetailItems?.isValueAllZero">
              {{ retailItems.value }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded?.isConsumer && impactItems.consumertransportList?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblTransportationConsumer }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConsumertransportList
                ?.isTransportmodeNameAllZero
            "
          >
            {{ reportResource.lblModeTransport }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConsumertransportList?.isFromplaceAllZero
            "
          >
            {{ reportResource.lblFrom }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConsumertransportList?.isToplaceAllZero
            "
          >
            {{ reportResource.lblTo }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showConsumertransportList?.isDistanceAllZero
            "
          >
            {{ reportResource.lblDistance }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let consumertransportList of impactItems.consumertransportList">
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConsumertransportList
                  ?.isTransportmodeNameAllZero
              "
            >
              {{ consumertransportList.transportmodeName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConsumertransportList?.isFromplaceAllZero
              "
            >
              {{ consumertransportList.fromplace }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConsumertransportList?.isToplaceAllZero
              "
            >
              {{ consumertransportList.toplace }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showConsumertransportList?.isDistanceAllZero
              "
            >
              {{ getShortDecimalFormat(consumertransportList.distance) | decimalFormatPipe }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="processIncluded?.isConsumer && impactItems.consumerItems?.length > 0"
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblConsumerDetails }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showConsumerItems?.isLabelAllZero">
            {{ reportResource.lblDescription }}
          </td>
          <td *ngIf="!impactItems?.showHideScenarioTables?.showConsumerItems?.isValueAllZero">
            {{ reportResource.lblInput }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let consumerItems of impactItems.consumerItems">
            <td *ngIf="!impactItems?.showHideScenarioTables?.showConsumerItems?.isLabelAllZero">
              {{ consumerItems.label }}
            </td>
            <td *ngIf="!impactItems?.showHideScenarioTables?.showConsumerItems?.isValueAllZero">
              {{ consumerItems.value }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="
    processIncluded?.isEOL &&
    impactItems.reuseFillertransportationItems?.length > 0 &&
    isVisibleTransportReuseTable
  "
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblTransportationReuse }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td>{{ reportResource.lblReusedComponent }}</td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                ?.isTransportmodeNameAllZero
            "
          >
            {{ reportResource.lblModeTransport }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                ?.isFromplaceAllZero
            "
          >
            {{ reportResource.lblFrom }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                ?.isToplaceAllZero
            "
          >
            {{ reportResource.lblTo }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                ?.isDistanceAllZero
            "
          >
            {{ reportResource.lblDistance }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container
          *ngFor="let reusefillingtransportdetail of impactItems.reuseFillertransportationItems"
        >
          <!-- Check if reuseFillingtransportationItems has items -->
          <ng-container
            *ngIf="reusefillingtransportdetail.reuseFillingtransportationItems?.length > 0"
          >
            <ng-container
              *ngFor="
                let items of reusefillingtransportdetail.reuseFillingtransportationItems;
                let i = index
              "
            >
              <tr>
                <ng-container *ngIf="i == 0">
                  <td
                    [attr.rowspan]="
                      reusefillingtransportdetail.reuseFillingtransportationItems.length
                    "
                  >
                    {{ reusefillingtransportdetail.componentName }}
                  </td>
                </ng-container>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                      ?.isTransportmodeNameAllZero
                  "
                  style="text-align: left"
                >
                  {{ items.transportmodeName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                      ?.isFromplaceAllZero
                  "
                  style="text-align: left"
                >
                  {{ items.fromplace }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                      ?.isToplaceAllZero
                  "
                  style="text-align: left"
                >
                  {{ items.toplace }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showReuseFillingtransportationItems
                      ?.isDistanceAllZero
                  "
                  style="text-align: left"
                >
                  {{ getShortDecimalFormat(items.distance) | decimalFormatPipe }}
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="row table-div"
  *ngIf="
    processIncluded?.isEOL &&
    impactItems.reuseFillertransportationItems?.length > 0 &&
    !!impactItems.reuseFillertransportationItems
  "
>
  <div class="tableHeadingForLifecycleStage">
    <div>{{ reportResource.lblReuseDetails }}</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                ?.isComponentNameAllZero
            "
          >
            {{ reportResource.lblReusedComponent }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                ?.isPercentageReuseAllZero
            "
          >
            {{ reportResource.lblReused }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                ?.isReuseProcessNameAllZero
            "
          >
            {{ reportResource.lblReuseProcess }}
          </td>
          <td
            *ngIf="
              !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                ?.isReuseCountryNameAllZero
            "
          >
            {{ reportResource.lblCountry }}
          </td>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr
            *ngFor="
              let reuseFillertransportationItems of impactItems.reuseFillertransportationItems
            "
          >
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                  ?.isComponentNameAllZero
              "
            >
              {{ reuseFillertransportationItems.componentName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                  ?.isPercentageReuseAllZero
              "
            >
              {{ reuseFillertransportationItems.percentageReuse }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                  ?.isReuseProcessNameAllZero
              "
            >
              {{ reuseFillertransportationItems.reuseProcessName }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillertransportationItems
                  ?.isReuseCountryNameAllZero
              "
            >
              {{ reuseFillertransportationItems.reuseCountryName }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div>
  <div class="row table-div" *ngIf="impactItems?.eolDetail?.reuseFillingData.length > 0">
    <div class="tableHeadingForLifecycleStage">{{ reportResource.lblEndLifeDetail }}</div>
    <div class="tableSubheadingForLifecycleStage">{{ reportResource.lblEolReuseOfComponent }}</div>
    <div *ngIf="isCheckISO">
      <p>{{ reportResource.lblEolDiscription }}</p>
    </div>
  </div>
  <div *ngIf="impactItems?.eolDetail?.reuseFillingData.length > 0" class="row table-div">
    <div class="tableHeadingForLifecycleStage">
      <div>{{ reportResource.lblReuse }}</div>
    </div>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillingData?.isComponentNameAllZero
              "
            >
              {{ reportResource.lblReuseComponent }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillingData
                  ?.isPercentageOfReuseAllZero
              "
            >
              {{ reportResource.lblReuseReuse }}
            </td>
            <td
              *ngIf="!impactItems?.showHideScenarioTables?.showReuseFillingData?.isReuseTypeAllZero"
            >
              {{ reportResource.lblReuseType }}
            </td>
            <td
              *ngIf="!impactItems?.showHideScenarioTables?.showReuseFillingData?.isNoOfTripAllZero"
            >
              {{ reportResource.lblReuseNoOfTrip }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillingData?.isProcessNameAllZero
              "
            >
              {{ reportResource.lblReuseProcessEol }}
            </td>
            <td
              *ngIf="
                !impactItems?.showHideScenarioTables?.showReuseFillingData
                  ?.isReuseProcesAmountAllZero
              "
            >
              {{ reportResource.lblReuseAmount }}
            </td>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let items of impactItems?.eolDetail?.reuseFillingData; let index = index">
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showReuseFillingData?.isComponentNameAllZero
                "
              >
                {{ items.componentName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showReuseFillingData
                    ?.isPercentageOfReuseAllZero
                "
              >
                {{ items.percentageOfReuse }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showReuseFillingData?.isReuseTypeAllZero
                "
              >
                {{ items.reuseType }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showReuseFillingData?.isNoOfTripAllZero
                "
              >
                {{ items.noOfTrip }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showReuseFillingData?.isProcessNameAllZero
                "
              >
                {{ items.processName }}
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showReuseFillingData
                    ?.isReuseProcesAmountAllZero
                "
              >
                {{ items.reuseProcesAmount }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div
    *ngIf="
      impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.columnCount > 0 ||
      impactItems?.eolDetail?.eolComponentList?.retailComponentList?.length > 0
    "
    class="row table-div"
  >
    <div class="tableHeadingForLifecycleStage">
      <div>Retail End-of-life</div>
    </div>
    <div class="tableSubheadingForLifecycleStage">
      Waste from pallet, traded and merchandizing packaging levels
    </div>
    <ng-container *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.columnCount > 0">
      <div class="tableHeadingForLifecycleStage">
        <div>{{ reportResource.lblEolFates }}</div>
      </div>

      <div class="table-content">
        <table class="table eolFateTable">
          <thead>
            <tr
              [ngClass]="
                impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.columnCount > 5
                  ? 'vertical_header'
                  : ''
              "
            >
              <td class="vertical_tr">{{ reportResource.lblMaterialName }}</td>
              <td class="vertical_tr">{{ reportResource.lblComponentName }}</td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.landfill">
                {{ reportResource.lblLandFill }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.recycling">
                {{ reportResource.lblRecycling }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.homecomposting">
                {{ reportResource.lblHomeComposting }}
              </td>
              <td
                *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.commercialcomposting"
              >
                {{ reportResource.lblCommercialComposting }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.incineration">
                {{ reportResource.lblIncineration }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.energyrecovery">
                {{ reportResource.lblWasteEnergyRecovery }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.opendump">
                {{ reportResource.lblOpenDump }}
              </td>
              <td
                *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.anaerobicdigestion"
              >
                {{ reportResource.lblAnerobicDigestion }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.litter">
                {{ reportResource.lblLitter }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.stormwater">
                {{ reportResource.lblStormWater }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.sewer">
                {{ reportResource.lblSewer }}
              </td>

              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.recyclingOpenLoop">
                {{ reportResource.lblRecyclingOpenLoop }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.chemicalRecycling">
                {{ reportResource.lblChemicalRecycling }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.pyrolysis">
                {{ reportResource.lblPyrolysis }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.openBurning">
                {{ reportResource.lblOpenBurning }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.none">
                {{ reportResource.lblNone }}
              </td>
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr *ngFor="let items of impactItems?.eolDetail?.retailEOLDetails">
                <td>{{ items.materialName }}</td>
                <td>{{ items.componentName }}</td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.landfill">
                  {{ items.landfill }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.recycling">
                  {{ items.recycling }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.homecomposting">
                  {{ items.homeComposting }}
                </td>
                <td
                  *ngIf="
                    impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.commercialcomposting
                  "
                >
                  {{ items.commercialComposting }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.incineration">
                  {{ items.incineration }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.energyrecovery">
                  {{ items.wasteEnergyRecovery }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.opendump">
                  {{ items.openDump }}
                </td>
                <td
                  *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.anaerobicdigestion"
                >
                  {{ items.anerobicDigestion }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.litter">
                  {{ items.litter }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.stormwater">
                  {{ items.stormWater }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.sewer">
                  {{ items.sewer }}
                </td>

                <td
                  *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.recyclingOpenLoop"
                >
                  {{ items.recyclingOpenLoop }}
                </td>
                <td
                  *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.chemicalRecycling"
                >
                  {{ items.chemicalRecycling }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.pyrolysis">
                  {{ items.pyrolysis }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.openBurning">
                  {{ items.openBurning }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowRetailEOLDetails?.none">
                  {{ items.none }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-container *ngIf="impactItems?.eolDetail?.eolComponentList?.retailComponentList?.length > 0">
      <div class="tableHeadingForLifecycleStage">
        <div>Component specific end-of-life settings</div>
      </div>
      <div class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showRetailComponentList
                    ?.isMaterialNameAllZero
                "
              >
                Material
              </td>
              <td
                *ngIf="!impactItems?.showHideScenarioTables?.showRetailComponentList?.isNameAllZero"
              >
                Component
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showRetailComponentList
                    ?.isRecyclabilityAllZero
                "
              >
                Recyclability
              </td>
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr
                *ngFor="let items of impactItems?.eolDetail?.eolComponentList?.retailComponentList"
              >
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showRetailComponentList
                      ?.isMaterialNameAllZero
                  "
                >
                  {{ items.materialName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showRetailComponentList?.isNameAllZero
                  "
                >
                  {{ items.name }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showRetailComponentList
                      ?.isRecyclabilityAllZero
                  "
                >
                  {{ items.recyclability }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="
      impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.columnCount > 0 ||
      impactItems?.eolDetail?.eolComponentList?.consumerComponentList?.length > 0
    "
    class="row table-div"
  >
    <div class="tableHeadingForLifecycleStage">
      <div>{{ reportResource.lblConsumerEndoflife }}</div>
    </div>
    <div class="tableSubheadingForLifecycleStage">
      Waste from retail and sub-retail packaging levels
    </div>
    <ng-container *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.columnCount > 0">
      <div class="tableHeadingForLifecycleStage">
        <div>{{ reportResource.lblEolFates }}</div>
      </div>
      <div class="table-content">
        <table class="table">
          <thead>
            <tr
              [ngClass]="
                impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.columnCount > 5
                  ? 'vertical_header'
                  : ''
              "
            >
              <td class="vertical_tr">{{ reportResource.lblMaterialName }}</td>
              <td class="vertical_tr">{{ reportResource.lblComponentName }}</td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.landfill">
                {{ reportResource.lblLandFill }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.recycling">
                {{ reportResource.lblRecycling }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.homecomposting">
                {{ reportResource.lblHomeComposting }}
              </td>
              <td
                *ngIf="
                  impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.commercialcomposting
                "
              >
                {{ reportResource.lblCommercialComposting }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.incineration">
                {{ reportResource.lblIncineration }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.energyrecovery">
                {{ reportResource.lblWasteEnergyRecovery }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.opendump">
                {{ reportResource.lblOpenDump }}
              </td>
              <td
                *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.anaerobicdigestion"
              >
                {{ reportResource.lblAnerobicDigestion }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.litter">
                {{ reportResource.lblLitter }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.stormwater">
                {{ reportResource.lblStormWater }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.sewer">
                {{ reportResource.lblSewer }}
              </td>
              <td
                *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.recyclingOpenLoop"
              >
                {{ reportResource.lblRecyclingOpenLoop }}
              </td>
              <td
                *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.chemicalRecycling"
              >
                {{ reportResource.lblChemicalRecycling }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.pyrolysis">
                {{ reportResource.lblPyrolysis }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.openBurning">
                {{ reportResource.lblOpenBurning }}
              </td>
              <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.none">
                {{ reportResource.lblNone }}
              </td>
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr *ngFor="let items of impactItems?.eolDetail?.consumerEOLDetails">
                <td>{{ items.materialName }}</td>
                <td>{{ items.componentName }}</td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.landfill">
                  {{ items.landfill }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.recycling">
                  {{ items.recycling }}
                </td>
                <td
                  *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.homecomposting"
                >
                  {{ items.homeComposting }}
                </td>
                <td
                  *ngIf="
                    impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.commercialcomposting
                  "
                >
                  {{ items.commercialComposting }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.incineration">
                  {{ items.incineration }}
                </td>
                <td
                  *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.energyrecovery"
                >
                  {{ items.wasteEnergyRecovery }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.opendump">
                  {{ items.openDump }}
                </td>
                <td
                  *ngIf="
                    impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.anaerobicdigestion
                  "
                >
                  {{ items.anerobicDigestion }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.litter">
                  {{ items.litter }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.stormwater">
                  {{ items.stormWater }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.sewer">
                  {{ items.sewer }}
                </td>
                <td
                  *ngIf="
                    impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.recyclingOpenLoop
                  "
                >
                  {{ items.recyclingOpenLoop }}
                </td>
                <td
                  *ngIf="
                    impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.chemicalRecycling
                  "
                >
                  {{ items.chemicalRecycling }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.pyrolysis">
                  {{ items.pyrolysis }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.openBurning">
                  {{ items.openBurning }}
                </td>
                <td *ngIf="impactItems?.eolDetail?.columnHideShowConsumerEOLDetails?.none">
                  {{ items.none }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-container
      *ngIf="impactItems?.eolDetail?.eolComponentList?.consumerComponentList?.length > 0"
    >
      <div class="tableHeadingForLifecycleStage">
        <div>Component specific end-of-life settings</div>
      </div>
      <div class="table-content">
        <table class="table">
          <thead>
            <tr>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showConsumerComponentList
                    ?.isMaterialNameAllZero
                "
              >
                Material
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showConsumerComponentList?.isNameAllZero
                "
              >
                Component
              </td>
              <td
                *ngIf="
                  !impactItems?.showHideScenarioTables?.showConsumerComponentList
                    ?.isRecyclabilityAllZero
                "
              >
                Recyclability
              </td>
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr
                *ngFor="
                  let items of impactItems?.eolDetail?.eolComponentList?.consumerComponentList
                "
              >
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showConsumerComponentList
                      ?.isMaterialNameAllZero
                  "
                >
                  {{ items.materialName }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showConsumerComponentList?.isNameAllZero
                  "
                >
                  {{ items.name }}
                </td>
                <td
                  *ngIf="
                    !impactItems?.showHideScenarioTables?.showConsumerComponentList
                      ?.isRecyclabilityAllZero
                  "
                >
                  {{ items.recyclability }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <!-- <div class="row table-div" *ngIf="processIncluded?.isEOL && impactItems?.endoflifeIdentifierItems?.length > 0 ">
        <div class="tableHeadingForLifecycleStage">
            <div>{{reportResource.lblEndLifeDetail}}</div>
        </div>
        <div *ngIf="isCheckISO">
            <p>{{reportResource.lblEolDiscription}}</p>
        </div>
        <div class="table-content">
            <table class="table">
                <thead>
                    <tr>
                        <td>{{reportResource.lblComponent}}</td>
                        <td *ngFor="let data of impactItems.endoflifeIdentifierItems">{{data.componentName}}</td>
                    </tr>
                </thead>
                <tbody>
                    <ng-container>
                        <tr
                            *ngFor="let endoflifeIdentifierItems of impactItems.endoflifeIdentifierItems[0].endoflifeIdentifierItems; let i =index">
                            <td>{{endoflifeIdentifierItems.label}}</td>
                            <td *ngFor="let data of impactItems?.endoflifeIdentifierItems ; let k = index">
                                {{data.endoflifeIdentifierItems[i]?.value}}%</td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div> -->
</div>

<ng-template #tipContent>
  <div *ngIf="transportDetail?.items?.transportaionId != 2">
    <span style="font-weight: bold">{{ transportDetail?.details?.transportModeName }}</span> -
    {{ transportDetail?.details?.distance }} ({{ transportDetail?.details?.unit }})
  </div>
  <div *ngIf="transportDetail?.items?.transportaionId == 2">
    <span style="font-weight: bold"> Location - </span>
    {{ transportDetail?.details?.transportDetail }} <br /><span style="font-weight: bold">{{
      transportDetail?.details?.transportModeName
    }}</span>
    - {{ transportDetail?.details?.distance }} ({{ transportDetail?.details?.unit }})
  </div>
</ng-template>
